import React from "react";

export default function IconBox(props) {
  const { size = 32, ...rest } = props;
  
  return (
    <img {...rest} width={size} height={size} 
      src={"/images/box.svg"} 
      alt="box icon" 
    />
  );
};